export const removePublicPageToken = ({ key }: { key: string }) => {
  try {
    localStorage.removeItem(key);
  } catch (_: unknown) {
    return null;
  }
};
